import { render, staticRenderFns } from "./ViajeAutorizaciones.vue?vue&type=template&id=46054fe2"
import script from "./ViajeAutorizaciones.vue?vue&type=script&lang=js"
export * from "./ViajeAutorizaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports